import { render, staticRenderFns } from "./CollectionRecordAddAmount.vue?vue&type=template&id=1bea0184&scoped=true"
import script from "./CollectionRecordAddAmount.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddAmount.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddAmount.vue?vue&type=style&index=0&id=1bea0184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea0184",
  null
  
)

export default component.exports